var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    {
      staticClass: "tabs boss-tabs-menu-list",
      attrs: { id: "boss-tab-menu", "data-tabs": "" },
    },
    [
      _vm.isPublishedBy(_vm.contractId, _vm.jobId)
        ? _c("scout-tab-recommendation")
        : _vm._e(),
      _vm._v(" "),
      !_vm.hasEndedContract(_vm.contractId)
        ? _c("scout-tab-search-condition", { attrs: { "job-id": _vm.jobId } })
        : _vm._e(),
      _vm._v(" "),
      _c("scout-tab-candidate"),
      _vm._v(" "),
      !_vm.isFutureContract(_vm.contractId)
        ? _c("scout-tab-scouted")
        : _vm._e(),
      _vm._v(" "),
      !_vm.isFutureContract(_vm.contractId)
        ? _c("scout-tab-reservation")
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }